import React, { useState, useEffect, useMemo, useRef, lazy } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import ModalSelectResources from "../ModalSelectResources";
import { useSelector, useDispatch } from "react-redux";
import {
  getData,
  inputChange,
  saveDataScrum,
  updateDataScrum,
  deleteDataScrum,
} from "../../../helpers";
import { selectTooltip, selectTooltip_en } from "../../../utils/selectTooltip";
import ReactTooltip from "react-tooltip";
import SelectInModal from "../SelectInModal";
import swal from "sweetalert";
import useTaskFiles from "./hooks/useTaskFiles";
import ModalSelectTags from "../ModalSelectTags";
import { useTranslation } from "react-i18next";

const ModalEditTaskPB = (props) => {
  const [t, i18n] = useTranslation("planning");
  const prevLaneId = useMemo(() => props.data.current.laneId);
  const [taskData, setTaskData] = useState({});
  const [showResources, setShowResources] = useState(false);
  const [showTags, setShowTags] = useState(false);
  const [showSelectHus, setShowSelectHus] = useState(false);
  const [selectedResources, setSelectedResources] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [filesName, setFilesName] = useState("");
  const [showNotes, setShowNotes] = useState(false);
  const [notesData, setNotesData] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [editNotes, setEditNotes] = useState(false);
  const [enableEdit, setEnableEdit] = useState();
  const scrum = useSelector((state) => state.scrum);

  const formTask = useRef();
  const filesInput = useRef();
  const noteref = useRef();

  const userStories = scrum.ddlStories.map((story, index) => {
    return {
      value: story.id,
      label: story.TituloHistoriaUsuario,
    };
  });

  const _getValue = (selector) => {
    if (
      typeof taskData.metadata != "undefined" &&
      typeof taskData.metadata[selector] != "undefined"
    ) {
      let val = taskData.metadata[selector];
      return val;
    } else {
      return null;
    }
  };

  const _changeInput = (e) => {
    const __returnZeroIfNumber = (type, value) => {
      if (type === "number" && value === "") {
        return 0;
      } else {
        return value;
      }
    };
    if (e.target.name === "title") {
      setTaskData((prev) => {
        // alert(e.target.name)
        return {
          ...prev,
          [e.target.name]: e.target.value,
        };
      });
    } else {
      setTaskData((prev) => {
        return {
          ...prev,
          metadata: {
            ...prev.metadata,
            [e.target.name]: __returnZeroIfNumber(
              e.target.type,
              e.target.value
            ),
          },
        };
      });
    }
  };

  const _saveTask = (data) => {
    let dummie = data;
    dummie.metadata.resources = selectedResources;
    dummie.metadata.tags = selectedTags;
    let adjuntos = [];
    /*  for (let i = 0; i < filesInput.current.files.length; i++) {
      const file = filesInput.current.files.item([i]);
      adjuntos.push(file);
    } */
    dummie.adjuntos = adjuntos;
    if (data.laneId !== prevLaneId) {
      dummie = {
        ...dummie,
        prevLaneId: prevLaneId,
      };
    }
    props.update(dummie);
    props.setShow(false);
  };

  useEffect(() => {
    if (!props.show) {
      /*  dispatchFiles({ type: "RESET" }); */
      setFilesName("");
      return;
    }
    if (props.data.current.metadata) {
      setTaskData(props.data.current);
      setSelectedResources(props.data.current.metadata.resources || []);
      setSelectedTags(props.data.current.metadata?.tags || []);
      getAllNotes(props.data.current.id);
    }
  }, [props.show]);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const getAllNotes = (taskId) => {
    Promise.all([getData(`agile-task-notes/${taskId}`, {})]).then((values) => {
      setNotesData(values[0]);
    });
  };

  const handleOnChangeForNotes = (e, id) => {
    if (e.target.name == "text")
      setNotesData((prev) => {
        prev.map((itprev) => {
          if (itprev.idComment == id) {
            itprev.text = e.target.value;
          }
          return itprev;
        });
        return [...prev];
      });
  };

  const handleEditNote = (id) => {
    setEnableEdit(id);
  };

  const createNewNote = (e) => {
    let newNoteData = {
      taskId: props.data.current.id,
      noteText: newNote.newComment,
    };
    saveDataScrum("agile-task-notes", newNoteData)
      .then((res) => {
        getAllNotes(newNoteData.taskId);
        noteref.current.value = "";
      })
      .catch((error) => {
        swal("¡Ups!", "Hubo un error al crear la nota", "error");
      });
  };

  const editNote = (id) => {
    let noteToEdit = notesData.filter((it) => it.idComment == id);
    const noteEdit = {
      id: noteToEdit[0].idComment,
      text: noteToEdit[0].text,
      idProject: noteToEdit[0].idProject,
    };
    updateDataScrum(`agile-task-notes/${noteEdit.id}`, noteEdit)
      .then((res) => {
        getAllNotes(props.data.current.id);
        setEnableEdit();
      })
      .catch((err) =>
        swal(
          "¡Ups!",
          "Hubo un error al actualizar los datos la nota, por favor refresca la página.",
          "error"
        )
      );
  };

  const deleteNote = (id) => {
    swal({
      title: t("modal_creationactivities_deletenote"),
      text: t("modal_creationactivities_deletenote_2"),
      icon: "warning",
      buttons: true,
      buttons: [
        t("modal_creationactivities_deletefile_3"),
        t("modal_creationactivities_deletefile_4"),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let noteToEdit = notesData.filter((it) => it.idComment == id);
        deleteDataScrum(
          `agile-task-notes-delete/${noteToEdit[0].idComment}`
        ).then((res) => {
          swal(
            t("modal_creationactivities_done"),
            t("modal_creationactivities_deletenote_5"),
            "success"
          ).catch((err) =>
            swal(
              "¡Ups!",
              "Hubo un error al eliminar la actividad, por favor refresca la página.",
              "error"
            )
          );
          getAllNotes(props.data.current.id);
        });
      }
    });
  };

  const commentsToShow = () => {
    if (notesData.length > 3 && showNotes == false) {
      let notesSlice = notesData.slice(0, 3);
      return notesSlice;
    } else return notesData;
  };

  const numberOfnotes = () => {
    if (notesData) {
      return notesData.length;
    }
  };

  const idProfileRol =
    window.localStorage.getItem("cm9sX3VzdWFyaW8=") == 108 ? true : false;

  const handleValidations = (e,taskdata) => {
    e.preventDefault()
    console.log(taskdata);
    _saveTask(taskdata);
    setTaskData({});
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => {
          props.setShow(false);
          setTaskData({});
        }}
        size="lg"
        contentClassName="border-0 shadow-lg"
      >
        <Form
          ref={formTask}
          id="form-comple"
          className={idProfileRol ? "disable-product-backlog" : ""}
        >
          <div
            className="progress rounded"
            title={`${taskData.metadata?.progress}% Completado`}
            style={{
              height: "8px",
              borderRadius: 0,
            }}
          >
            <div
              className={`progress-bar ${
                taskData.metadata?.progress < 100 ? "bg-info" : "bg-success"
              }`}
              role="progressbar"
              style={{ width: `${taskData.metadata?.progress}%` }}
            ></div>
          </div>
          <Modal.Header>
            <Modal.Title className="h5 w-100">
              <input
                type="text"
                placeholder="Nombre del item"
                name="title"
                disabled={
                  props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo"
                    ? true
                    : false
                }
                value={taskData.title || ""}
                className="border-0"
                style={{ width: "100%" }}
                onChange={(e) => {
                  _changeInput(e);
                }}
              />
            </Modal.Title>
            <Button
              onClick={(e) => {
                props.setShow(false);
              }}
              variant="light"
            >
              X
            </Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Row>
                  <Col lg={12}>
                    <div
                      className="mb-3 d-inline-block"
                      onClick={() => {
                        if (
                          props.rol == "Miembro de Equipo" ||
                          props.rol == "Ejecutivo"
                        ) {
                          return;
                        } else {
                          setShowTags(true);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa fa-tags text-muted mr-2"></i>
                      {selectedTags.length > 0 ? (
                        selectedTags.map((item) => {
                          return (
                            <span
                              style={{ backgroundColor: item.Color }}
                              key={item.Id}
                              className="badge text-white mr-1"
                            >
                              {item.NombreEtiqueta}
                            </span>
                          );
                        })
                      ) : (
                        <span className="text-primary">
                          {t("modal_creationactivities_text2")}
                        </span>
                      )}
                    </div>
                  </Col>
                  <div className="d-flex w-100 mb-2">
                    {!props.hideStories && (
                      <Col md={6} lg={6}>
                        <Form.Group>
                          <Form.Label>
                            {t("modal_creationactivities_text11")}
                          </Form.Label>
                          <Form.Control
                            as="select"
                            name="HistoriaUsuarioId"
                            value={_getValue("HistoriaUsuarioId")}
                            onClick={(e) => {
                              setShowSelectHus(true);
                            }}
                            onChange={(e) => {
                              _changeInput(e);
                            }}
                            disabled={
                              props.rol == "Miembro de Equipo" ||
                              props.rol == "Ejecutivo"
                                ? true
                                : false
                            }
                          >
                            <option value="">
                              {t("modal_editsprint_text2_1")}...
                            </option>
                            {userStories !== undefined &&
                              userStories.map((item, index) => {
                                return (
                                  <option key={item.value} value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })}
                          </Form.Control>
                          <SelectInModal
                            title={t("modal_creationactivities_text11_1")}
                            noneLabel={t("modal_creationactivities_text11_6")}
                            show={showSelectHus}
                            value={_getValue("HistoriaUsuarioId")}
                            onClose={() => {
                              setShowSelectHus(false);
                            }}
                            items={userStories} // all hus
                            name="HistoriaUsuarioId"
                            onChange={(e) => _changeInput(e)}
                          />
                        </Form.Group>
                      </Col>
                    )}
                  </div>
                  <div className="d-flex w-100 mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label
                          data-tip={
                            t("planningboard_lenguaje") == "es"
                              ? selectTooltip(34)
                              : selectTooltip_en(34)
                          }
                          data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                        >
                          {t("modal_creationactivities_text12")}
                        </Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="0"
                          step={0.1}
                          min="1"
                          name="HorasEjecutadas"
                          value={_getValue("HorasEjecutadas")}
                          onFocus={(e) => {
                            e.target.select();
                          }}
                          onChange={(e) => {
                            _changeInput(e);
                          }}
                          disabled={
                            props.rol == "Miembro de Equipo" ||
                            props.rol == "Ejecutivo"
                              ? true
                              : false
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label
                          data-tip={
                            t("planningboard_lenguaje") == "es"
                              ? selectTooltip(40)
                              : selectTooltip_en(40)
                          }
                          data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                        >
                          {t("modal_creationactivities_text13")}{" "}
                          <small>(1 - 100)</small>
                        </Form.Label>
                        <Form.Control
                          /* isValid={(_getValue("poValue") >= 0 && _getValue("poValue") <= 100 )? true : false} */
                          type="number"
                          placeholder="0"
                          min="1"
                          max="100"
                          maxLength={3}
                          name="poValue"
                          value={_getValue("poValue")}
                          onFocus={(e) => {
                            e.target.select();
                          }}
                          onChange={(e) => {
                            if (e.target.value > 100) {
                              return;
                            } else {
                              _changeInput(e);
                            }
                            /*   _changeInput(e); */
                          }}
                          disabled={
                            props.rol == "Miembro de Equipo" ||
                            props.rol == "Ejecutivo"
                              ? true
                              : false
                          }
                        />
                      </Form.Group>
                    </Col>
                  </div>
                  {notesData?.length > 3 && (
                    <Button
                      variant="outline-info"
                      size="sm"
                      className="mt-0 mb-2"
                      onClick={() => {
                        setShowNotes((value) => (value = !value));
                      }}
                    >
                      {!showNotes ? (
                        <>
                          {t("modal_creationactivities_notes_4")}({" "}
                          {numberOfnotes()} )
                        </>
                      ) : (
                        <>{t("modal_creationactivities_notes_5")}( 3 )</>
                      )}
                    </Button>
                  )}
                  <Col lg={12}>
                    <Row
                      className="px-4 mb-0"
                      style={{
                        backgroundColor: "#e9ecef",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        maxHeight: "365px",
                        overflowY: "auto",
                      }}
                    >
                      {notesData.length == 0 && (
                        <Form.Label className="mb-1 mt-2">
                          <b>{t("modal_creationactivities_text19")}</b>
                        </Form.Label>
                      )}
                      {notesData.length >= 1 && (
                        <Form.Label className="mb-1">
                          {t("modal_creationactivities_notes_6")}
                        </Form.Label>
                      )}
                      <Col lg={12}>
                        {commentsToShow() ? (
                          <>
                            {commentsToShow()?.map((item, idx) => {
                              return (
                                <Col
                                  key={idx + 1}
                                  lg={12}
                                  className="mb-0 pb-0 d-flex border-bottom rounded border-2 border-light"
                                  style={{ backgroundColor: "#e9ecef" }}
                                >
                                  <div
                                    style={{ width: "100%" }}
                                    className="mr-2 "
                                  >
                                    <small className="mr-2">{item.name}</small>
                                    <small>
                                      {t("modal_creationactivities_notes_1")}{" "}
                                      {item.createDate}
                                    </small>
                                    <Form.Control
                                      key={idx}
                                      as="textarea"
                                      className="mb-1 pb-0"
                                      style={{ border: "none" }}
                                      name="text"
                                      value={item.text}
                                      disabled={
                                        idx == enableEdit ? false : true
                                      }
                                      onChange={(e) => {
                                        handleOnChangeForNotes(
                                          e,
                                          item.idComment
                                        );
                                      }}
                                    />
                                  </div>
                                  <div className="d-flex justify-content-around align-items-center">
                                    {idx != enableEdit ? (
                                      <>
                                        <i
                                          className="text-info fa fa-edit mr-2"
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            if (props.rol != "Ejecutivo") {
                                              handleEditNote(idx);
                                            } else {
                                              return;
                                            }
                                          }}
                                        ></i>
                                        <i
                                          className="text-danger fas fa-trash"
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            if (props.rol != "Ejecutivo") {
                                              deleteNote(item.idComment);
                                            } else {
                                              return;
                                            }
                                          }}
                                        ></i>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {idx == enableEdit ? (
                                      <>
                                        <div className="d-flex flex-column">
                                          <Button
                                            type="button"
                                            variant="info"
                                            size="sm"
                                            className="p-1 mb-1"
                                            onClick={(e) => {
                                              editNote(item.idComment);
                                            }}
                                          >
                                            {t(
                                              "modal_creationactivities_button_save"
                                            )}
                                          </Button>
                                          <Button
                                            type="button"
                                            variant="dark"
                                            size="sm"
                                            className="p-1 m-0"
                                            onClick={(e) => {
                                              setEnableEdit();
                                              setEditNotes(false);
                                              getAllNotes(
                                                props.data.current.id
                                              );
                                            }}
                                          >
                                            {t(
                                              "modal_creationactivities_button_cancel"
                                            )}
                                          </Button>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </Col>
                              );
                            })}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <Row>
                      <Form
                        style={{
                          backgroundColor: "#e9ecef",
                          borderBottomLeftRadius: "5px",
                          borderBottomRightRadius: "5px",
                        }}
                        className="w-100 mb-2 px-3"
                      >
                        {notesData?.length >= 1 && (
                          <Form.Label>
                            <b>{t("modal_creationactivities_notes_2")}</b>
                          </Form.Label>
                        )}
                        <Col lg={12} md={12}>
                          <Form.Control
                            ref={noteref}
                            as="textarea"
                            className="mb-2"
                            name="newComment"
                            placeholder={t("modal_creationactivities_text20")}
                            onChange={(e) => {
                              inputChange(e, setNewNote);
                            }}
                          />
                          <Button
                            type="button"
                            variant="success"
                            size="sm"
                            className="p-1 mb-2"
                            onClick={(e) => {
                              createNewNote(e);
                            }}
                            disabled={props.rol == "Ejecutivo" ? true : false}
                          >
                            <icon class="fa fa-sticky-note mr-2" />
                            {t("modal_creationactivities_notes_3")}
                          </Button>
                        </Col>
                      </Form>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              variant="dark"
              onClick={(e) => {
                setTaskData({});
                props.setShow(false);
              }}
            >
              <i className="fa fa-times mr-2"></i>
              {t("modal_creationactivities_button_cancel")}
            </Button>
            <Button
              type="submit"
        
              variant="success"
              onClick={(e) => handleValidations(e,taskData)}
              disabled={props.rol == "Ejecutivo" ? true : false}
            >
              <i className="fa fa-save mr-2"></i>
              {t("modal_creationactivities_button_save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <ModalSelectResources
        show={showResources}
        setShow={setShowResources}
        resources={props.resources} // all resources
        selectedResources={selectedResources} // selected resources
        setResources={setSelectedResources}
      />
      <ModalSelectTags
        show={showTags}
        setShow={setShowTags}
        tags={props.tags}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
      />
    </>
  );
};

export default ModalEditTaskPB;
